import { useState } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { isTrellisTheme, useTheme } from 'foundations-theming/utils';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Button } from 'foundations-components/transitional/components/Button';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { useAuthState } from '../../../app/hooks/useAuthState';
import { GATES_MANUALLY_DISABLED_LEAVE_BETA } from '../../constants';
import LeaveBetaDialog from '../EnrollmentButtonDialogs/LeaveBetaDialog';
import useFetchOrgData from '../../hooks/useFetchOrgData';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function LeaveEnrollmentButton({
  enrollmentStatus,
  enrollType,
  gate,
  productUpdateId,
  rolloutId,
  rolloutState,
  size,
  title,
  untranslatedTitle
}) {
  const theme = useTheme();
  const isTrellis = isTrellisTheme(theme);
  const [leavePrivateDialogOpen, setLeavePrivateDialogOpen] = useState(false);
  const [leavePublicDialogOpen, setLeavePublicDialogOpen] = useState(false);
  const {
    user,
    hasBetaAccess
  } = useAuthState();
  const userId = (user === null || user === void 0 ? void 0 : user.user_id) || -1;
  const leaveBetaManuallyDisabled = GATES_MANUALLY_DISABLED_LEAVE_BETA.includes(gate);
  const {
    isInOrgAndSuperAdmin,
    loading
  } = useFetchOrgData();
  const btnUseSecondary = isTrellis ? 'secondary' : 'tertiary-light';
  const getDisabledMessage = () => {
    if (!hasBetaAccess) {
      return I18n.text('app.betas.disabled.noScope');
    } else if (enrollmentStatus === 'ENROLLED_CANNOT_LEAVE') {
      return I18n.text('app.buttons.automaticTooltip');
    } else if (leaveBetaManuallyDisabled) {
      return I18n.text('app.buttons.leaveDisabled');
    } else if (!isInOrgAndSuperAdmin) {
      return I18n.text('app.betas.disabled.notOrgSuperAdmin');
    } else return null;
  };
  const isDisabled = !hasBetaAccess || enrollmentStatus === 'ENROLLED_CANNOT_LEAVE' || leaveBetaManuallyDisabled || enrollType === 'ORGANIZATIONS_ONLY' && !isInOrgAndSuperAdmin;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Tooltip, {
      disabled: !isDisabled,
      title: getDisabledMessage(),
      children: enrollType === 'ORGANIZATIONS_ONLY' ? /*#__PURE__*/_jsx(LoadingButton, {
        loading: loading,
        failed: true,
        disabled: isDisabled,
        use: btnUseSecondary,
        size: size,
        block: true,
        onClick: () => {
          if (rolloutState === 'PRIVATE_BETA') {
            setLeavePrivateDialogOpen(true);
          } else {
            setLeavePublicDialogOpen(true);
          }
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.buttons.leave"
        })
      }) : /*#__PURE__*/_jsx(Button, {
        disabled: isDisabled,
        use: btnUseSecondary,
        size: size,
        block: true,
        onClick: () => {
          if (rolloutState === 'PRIVATE_BETA') {
            setLeavePrivateDialogOpen(true);
          } else {
            setLeavePublicDialogOpen(true);
          }
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.buttons.leave"
        })
      })
    }), leavePrivateDialogOpen && /*#__PURE__*/_jsx(LeaveBetaDialog, {
      userId: userId,
      productUpdateId: productUpdateId,
      rolloutId: rolloutId,
      title: title,
      gate: gate,
      untranslatedTitle: untranslatedTitle,
      enrollmentStatus: enrollmentStatus,
      enrollType: enrollType,
      betaAccessType: "PRIVATE",
      onClose: () => {
        setLeavePrivateDialogOpen(false);
      }
    }), leavePublicDialogOpen && /*#__PURE__*/_jsx(LeaveBetaDialog, {
      userId: userId,
      productUpdateId: productUpdateId,
      rolloutId: rolloutId,
      title: title,
      gate: gate,
      untranslatedTitle: untranslatedTitle,
      enrollmentStatus: enrollmentStatus,
      enrollType: enrollType,
      betaAccessType: "PUBLIC",
      onClose: () => {
        setLeavePublicDialogOpen(false);
      }
    })]
  });
}